import { useAppSelector } from "app/redux/hooks"
import { IOrcamento } from "app/types/IOrcamento"
import React, { useEffect, useReducer, useState } from "react"
import { Permissao } from "../../../app/types/Permissao"
import { obterPermissao } from "../../../app/use-cases/obterPermissao"
import globalMU from "../../../globalMU"
import { Abas } from "../abas/Abas"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { InclusaoEdicaoAbaProfissionaisContainer } from "./aba-profissionais/inclusao-edicao-aba-profissionais/InclusaoEdicaoAbaProfissionaisContanier"
import { AdicionarVendedoresContainer } from "./aba-vendedores/adicionar-vendedor/AdicionarVendedorContainer"
import { DetalhesComissoesContainer } from "./aba-indicadores-pesquisa/detalhes-comissao/DetalhesComissaoContainer"
import { IndicadoresContainer } from "./aba-indicadores-pesquisa/IndicadoresContainer"
import { AbaProfissionaisContainer } from "./aba-profissionais/AbaProfissionaisContainer"
import { TelaCadastroIndicadoresContainer } from "./cadastro-indicador/TelaCadastroIndicadoresContainer"
import { VendedoresContainer } from "./aba-vendedores/VendedoresContainer"
import { DadosAbaProfissionais } from "./aba-profissionais/AbaProfissionais"
import { v4 as uuidv4 } from 'uuid'
import { DadosInclusaoEdicaoAbaProfissionais } from "./aba-profissionais/inclusao-edicao-aba-profissionais/InclusaoEdicaoAbaProfissionais"
import { DadosAbaVendedores } from "./aba-vendedores/PesquisaAbaVendedores"
import { DadosAbaIndicadores } from "./aba-indicadores-pesquisa/PesquisaIndicadores"
import { removerIndicador } from "app/use-cases/orcamento/comissoes/detalharComissoesPorIndicador"
import { tratamentoErroPadrao } from "app/use-cases"
import { Parametro } from "app/types/Parametro"
import { obterParametros } from "app/use-cases/parametro/obterParametros"


type NomesAbas = "Indicadores" | "Vendedores" | "Profissionais"

export type TelaComissoesContainerProps = {
    abaSelecionada?: NomesAbas
}

export type dadosAbas = {
    dadosAbaIndicadores: DadosAbaIndicadores,
    dadosAbaProfissionais: DadosAbaProfissionais,
    dadosAbaVendedores: DadosAbaVendedores,
    inclusaoEdicaoAbaProfissionais: DadosInclusaoEdicaoAbaProfissionais
}

export const TelaComissoesContainer = (props: TelaComissoesContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)

    const [abaSelecionada, setAbaSelecionada] = useState<NomesAbas>(props.abaSelecionada ?? "Indicadores")
    const [permissoes, setPermissoes] = useState<Permissao[]>([])
    const [abas, setAbas] = useState<{ nome: string }[]>([])

    const [exibeDetalheComissoes, setExibeDetalheComissoes] = useState(false);
    const [ExibeAdicionarVendedor, setExibeAdicionarVendedor] = useState(false);
    const [exibeEditarProfissionais, setExibeEditarProfissionais] = useState(false);

    const [executarAcaoLimparIndicadores, setExecutarAcaoLimparIndicadores] = useState(uuidv4());
    const [executarAcaoLimparAbaVendedores, setExecutarAcaoLimparAbaVendedores] = useState(uuidv4());
    const [executarAcaoLimparProfissionais, setExecutarAcaoLimparProfissionais] = useState(uuidv4());

    const [botaoCancelarProfissionais, setBotaoCancelarProfissionais] = useState(false);
    const [botaoCancelarVendedores, setBotaoCancelarVendedores] = useState(false);
    const [botaoEditarIndicador, setBotaoEditarIndicador] = useState(false)
    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [parametrosCarregados, setParametrosCarregados] = useState(false)

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const initialStateDadosAba: dadosAbas = {
        dadosAbaIndicadores: {
            abaIndicadores: { Nome: "", CpfCnpj: "", Todos: false },
            indicadores: {}
        },
        dadosAbaVendedores: {
            abaVendedores: { Nome: "", Codigo: "" },
            vendedores: {},
            vendedoresSelecionados: []
        },
        dadosAbaProfissionais: {
            abaProfissionaisFormulario: { Nome: "" },
            listaPesquisa: {},
            listaProfissionaisTipo: {},
            profissionaisSelecionados: []
        },
        inclusaoEdicaoAbaProfissionais: {
            profissionaisSelecionados: [],
            listaProfissionaisTipo: {}
        }
    }

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    "TRABALHA_COM_INDICACAO_PROFISSIONAIS",
                    "ORCAMENTO_CONTROLA_VENDEDOR_SETORES",
                    "PERMITE_VENDA_MAIS_DE_UM_VENDEDOR",
                ],
            })
        );
    };


    const [dadosAba, setDadosAba] = useReducer(
        (prevState: dadosAbas, nextState: Partial<dadosAbas>) => ({ ...prevState, ...nextState }),
        initialStateDadosAba
    )

    const exibirAbaIndicadores = () => {
        return globalMU.possuiPermissao(permissoes, "ORCAMENTO_INDICADORES")
    }

    const exibirAbaVendeores = () => {
        return (globalMU.possuiPermissao(permissoes, "ORCAMENTO_VENDEDORES")  && valorParametro("PERMITE_VENDA_MAIS_DE_UM_VENDEDOR") === "S" && valorParametro("ORCAMENTO_CONTROLA_VENDEDOR_SETORES") !== "S")
    }

    const exibirAbaProfissionais = () => {
        return (globalMU.possuiPermissao(permissoes, "ORCAMENTO_PROFISSIONAIS") && valorParametro("TRABALHA_COM_INDICACAO_PROFISSIONAIS") === "S")
    }


    const atualizarPermissoes = async () => {
        setPermissoes([
            {
                Funcionalidade: "ORCAMENTO_INDICADORES",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_INDICADORES" })
            },
            {
                Funcionalidade: "ORCAMENTO_VENDEDORES",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_VENDEDORES" })
            },
            {
                Funcionalidade: "ORCAMENTO_PROFISSIONAIS",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_PROFISSIONAIS" })
            }
        ])
    }

    const atualizarAbas = () => {
        const abasPermitidas = [
            {
                nome: exibirAbaIndicadores() ? "Indicadores" : undefined
            },
            {
                nome: exibirAbaVendeores() ? "Vendedores" : undefined
            },
            {
                nome: exibirAbaProfissionais() ? "Profissionais" : undefined
            }
        ].filter(aba => aba.nome != undefined)
        setAbas(abasPermitidas)
        setAbaSelecionada(abasPermitidas[0] ? abasPermitidas[0].nome as NomesAbas : "Indicadores");
    }

    const editarIndicador = () => {
        renderizarComponentReact(<TelaCadastroIndicadoresContainer codigoIndicador={orcamento.Indicador.Codigo} />, "conteudo-pagina", true)
    }
    const onlimparIndicador = async () => {
        try {
            globalMU.blockUI();
            await removerIndicador()
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const limpar = () => {
        switch (abaSelecionada) {
            case "Indicadores":
                ((setDadosAba(initialStateDadosAba)), onOcultarDetalhesComissao(), onlimparIndicador(), setExecutarAcaoLimparIndicadores(uuidv4()))
                break;
            case "Vendedores":
                ((setDadosAba(initialStateDadosAba)), setExecutarAcaoLimparAbaVendedores(uuidv4()))
                break;
            case "Profissionais":
                (setDadosAba(initialStateDadosAba), setExecutarAcaoLimparProfissionais(uuidv4()))
                break;

        }
    }

    const verficaSeTemDadosNoRedux = () => {
        if (orcamento.Indicador != null && orcamento.Indicador != undefined)
            if (orcamento.Indicador.length > 0)
                setExibeDetalheComissoes(true);

        if (orcamento.Vendedores != null && orcamento.Vendedores != undefined)
            if (orcamento.Vendedores.length > 0)
                setExibeAdicionarVendedor(true);

        if (orcamento.Profissionais != null && orcamento.Profissionais != undefined)
            if (orcamento.Profissionais.length > 0)
                setExibeEditarProfissionais(true);
    }

    useEffect(() => {
        atualizarParametros()
        atualizarPermissoes()
        verficaSeTemDadosNoRedux()
        setParametrosCarregados(true)
    }, [])

    useEffect(() => {
        setBotaoCancelarProfissionais(false)
    }, [abaSelecionada])

    useEffect(() => {
        atualizarAbas()
    }, [permissoes])

    useEffect(() => {
        if (abaSelecionada == "Indicadores" && orcamento.Indicador != null) {
            setBotaoEditarIndicador(true);
            setExibeDetalheComissoes(true);
        }
        else {
            setBotaoEditarIndicador(false);
            setExibeDetalheComissoes(false);
        }
    }, [abaSelecionada, orcamento.Indicador])

    const onOcultarDetalhesComissao = () => {
        setExibeDetalheComissoes(false);
    }

    const onDesativarIncluirVendedor = (semVendedoresAdiconados: boolean) => {
        setBotaoCancelarVendedores(!semVendedoresAdiconados);
        setExibeAdicionarVendedor(false);
    }

    const onDesativarIncluirProfissional = (semProfissionaisAdiconados: boolean) => {
        setDadosAba(initialStateDadosAba)
        setExibeEditarProfissionais(false);
        setBotaoCancelarProfissionais(!semProfissionaisAdiconados);
    }

    return (
        <>
            {parametrosCarregados && <>
                <Breadcrumb2Container
                    passos={["Comissões"]}
                    id="TelaComissoesContainer"
                    exibirBotaoLimpar={!orcamento.SomenteLeitura}
                    exibirBotaoVoltar={false}
                    exibirBotaoEditar={!orcamento.SomenteLeitura && botaoEditarIndicador}
                    onBotaoLimparClicado={limpar}
                    onBotaoEditaClicado={editarIndicador}
                />

                <div className="_mt-2 _border-b _border-solid _border-[#ddd] _shadow-[0_6px_rgb(0_0_0/3%)]">
                    <Abas
                        abas={abas}
                        id="TelaComissoesAbas"
                        nomeAbaSelecionada={abaSelecionada}
                        onAbaSelecionada={nome => setAbaSelecionada(nome as NomesAbas)} />
                </div>

                {abaSelecionada == "Indicadores" &&
                    (!exibeDetalheComissoes ?
                        <IndicadoresContainer
                            key={executarAcaoLimparIndicadores}
                            {...dadosAba.dadosAbaIndicadores}
                            exibeDetalhesComissoes={setExibeDetalheComissoes}
                            onAlteradoDadosIndicadores={(dados) => setDadosAba({ dadosAbaIndicadores: dados })}
                        />
                        :
                        <DetalhesComissoesContainer
                            key={executarAcaoLimparIndicadores}
                        />
                    )
                }

                {abaSelecionada == "Vendedores" &&
                    (!ExibeAdicionarVendedor ?
                        <VendedoresContainer
                            key={executarAcaoLimparAbaVendedores}
                            {...dadosAba.dadosAbaVendedores}
                            mostrarBotaoCancelar={botaoCancelarVendedores}
                            onExibeAdicionarVendedor={setExibeAdicionarVendedor}
                            onAlteradoDadosAbaVendedores={(dados) => setDadosAba({ dadosAbaVendedores: dados })}
                        />
                        :
                        <AdicionarVendedoresContainer
                            onDesativarIncluirVendedor={onDesativarIncluirVendedor}
                        />
                    )

                }

                {abaSelecionada == "Profissionais" &&
                    (!exibeEditarProfissionais ?
                        <AbaProfissionaisContainer
                            key={executarAcaoLimparProfissionais}
                            {...dadosAba.dadosAbaProfissionais}
                            mostrarBotaoCancelar={botaoCancelarProfissionais}
                            onAtivarIncluirProfissional={setExibeEditarProfissionais}
                            onAlteradoDadosProfissionais={(dados) => setDadosAba({ dadosAbaProfissionais: dados })}
                        />
                        :
                        <InclusaoEdicaoAbaProfissionaisContainer
                            {...dadosAba.inclusaoEdicaoAbaProfissionais}
                            onAlteradoDadosInclusaoEdicaoAbaProfissionais={(dados) => setDadosAba({ inclusaoEdicaoAbaProfissionais: dados })}
                            onDesativarIncluirProfissional={onDesativarIncluirProfissional}
                        />
                    )
                }
            </>}
        </>

    )
}
